"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskReviewCycle () {
        return AutoflowTaskReviewCycle;
    },
    get AutoflowTaskReviewCycleAddUsers () {
        return AutoflowTaskReviewCycleAddUsers;
    },
    get AutoflowTaskReviewCycleAddUsersResponse () {
        return AutoflowTaskReviewCycleAddUsersResponse;
    },
    get AutoflowTaskReviewCycleBase () {
        return AutoflowTaskReviewCycleBase;
    },
    get AutoflowTaskReviewCycleCheckCompletion () {
        return AutoflowTaskReviewCycleCheckCompletion;
    },
    get AutoflowTaskReviewCycleCheckCompletionResponse () {
        return AutoflowTaskReviewCycleCheckCompletionResponse;
    },
    get AutoflowTaskReviewCycleExcludeExistingSubjects () {
        return AutoflowTaskReviewCycleExcludeExistingSubjects;
    },
    get AutoflowTaskReviewCycleExcludeExistingSubjectsResponse () {
        return AutoflowTaskReviewCycleExcludeExistingSubjectsResponse;
    },
    get AutoflowTaskReviewCycleResponse () {
        return AutoflowTaskReviewCycleResponse;
    },
    get TaskReviewCycleConfig () {
        return TaskReviewCycleConfig;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _taskbase = require("./task-base");
const TaskReviewCycleConfig = _taskbase.AutoflowTaskConfigBase.extend({
    review_cycle_id: _zod.z.instanceof(_bson.ObjectId)
});
const AutoflowTaskReviewCycleBase = _taskbase.AutoflowTaskBase.extend({
    task_type: _zod.z.literal("review-cycle:"),
    config: TaskReviewCycleConfig
});
const AutoflowTaskReviewCycleAddUsers = AutoflowTaskReviewCycleBase.extend({
    task_type: _zod.z.literal("review-cycle:add-users"),
    config: TaskReviewCycleConfig.extend({}),
    // This isn't perfect, we want to require at least one input task to have userIds property,
    // but currently this requires all tasks to have it
    // { "task-id": { userIds: ObjectId[] | null }}
    inputs: _zod.z.record(_zod.z.string(), _zod.z.object({
        user_ids: _zod.z.instanceof(_bson.ObjectId).array().or(_zod.z.null())
    }))
});
const AutoflowTaskReviewCycleAddUsersResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskReviewCycleAddUsers).extend({
    outputs: _zod.z.object({
        user_ids_to_add: _zod.z.instanceof(_bson.ObjectId).array(),
        user_ids_added: _zod.z.instanceof(_bson.ObjectId).array()
    })
});
const AutoflowTaskReviewCycleCheckCompletion = AutoflowTaskReviewCycleBase.extend({
    task_type: _zod.z.literal("review-cycle:check-completion"),
    config: TaskReviewCycleConfig.extend({}),
    // Optionally require an input task
    inputs: _zod.z.record(_zod.z.string(), _zod.z.any()).optional()
});
const AutoflowTaskReviewCycleCheckCompletionResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskReviewCycleCheckCompletion).extend({
    outputs: _zod.z.object({
        completed: _zod.z.boolean().nullable()
    })
});
const AutoflowTaskReviewCycleExcludeExistingSubjects = AutoflowTaskReviewCycleBase.extend({
    task_type: _zod.z.literal("review-cycle:exclude-existing-subjects"),
    config: TaskReviewCycleConfig.extend({}),
    inputs: _zod.z.record(_zod.z.string(), _zod.z.object({
        user_ids: _zod.z.instanceof(_bson.ObjectId).array().or(_zod.z.null())
    }))
});
const AutoflowTaskReviewCycleExcludeExistingSubjectsResponse = _taskbase.AutoflowTaskBaseResponse.merge(AutoflowTaskReviewCycleExcludeExistingSubjects).extend({
    outputs: _zod.z.object({
        user_ids: _zod.z.instanceof(_bson.ObjectId).array()
    })
});
const AutoflowTaskReviewCycle = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskReviewCycleAddUsers,
    AutoflowTaskReviewCycleCheckCompletion,
    AutoflowTaskReviewCycleExcludeExistingSubjects
]);
const AutoflowTaskReviewCycleResponse = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskReviewCycleAddUsersResponse,
    AutoflowTaskReviewCycleCheckCompletionResponse,
    AutoflowTaskReviewCycleExcludeExistingSubjectsResponse
]);
